import { Typography } from "@mui/material";

export const Inbox = () => {
    return (
        <Typography 
            variant="h4"
            sx={{
                textAlign: 'center',
                margin: '25px auto'
            }} 
        >
            Welcome to Admin Dashboard!
        </Typography>
    );
}
    